/**
 * Interface for notification requests that target users by username.
 */
export interface IRequestByUsername {
    /**
     * Gets or sets the recipients.
     */
    recipients: Array<string>;

    /**
     * Validates the request.
     */
    validate(): void;
}
